import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const MetricWidget = ({ title, value, subtitle, icon: Icon, trend, className }) => {
  return (
    <Card
      data-testid={`metric-${title.toLowerCase().replace(/\s+/g, '-')}`}
      className={cn(
        "metric-glow border-white/5 bg-card rounded-sm hover:bg-white/[0.03] transition-colors duration-200",
        className
      )}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <p className="text-xs font-bold tracking-widest uppercase text-muted-foreground">
              {title}
            </p>
            <p className="text-3xl font-bold tracking-tight text-foreground" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              {value}
            </p>
            {subtitle && (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div className="w-10 h-10 rounded-sm bg-blue-500/10 flex items-center justify-center">
              <Icon className="w-5 h-5 text-blue-400" strokeWidth={1.5} />
            </div>
          )}
        </div>
        {trend !== undefined && (
          <div className="mt-3 flex items-center gap-1.5">
            <span className={cn(
              "text-xs font-semibold",
              trend >= 0 ? "text-emerald-400" : "text-red-400"
            )}>
              {trend >= 0 ? "+" : ""}{trend}%
            </span>
            <span className="text-xs text-muted-foreground">vs last month</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
